/**
 * Handles opening media dialogs and restarting the media inside the iframe
 * To use a media dialog you need a <button> with class 'js-media-dialog-open-button'
 * and a <dialog> with class 'js-media-dialog-modal'
 */
export const initializeMediaDialog = () => {
    const dialogWrappers = document.querySelectorAll(".js-media-dialog-wrapper");

    if (!dialogWrappers.length) return;

    dialogWrappers.forEach((dialogWrapper) => {
        const openButton = dialogWrapper.querySelector(".js-media-dialog-open-button");
        const dialog = dialogWrapper.querySelector(".js-media-dialog-modal");

        if (!openButton || !dialog) return;

        openButton.addEventListener("click", () => {
            dialog.showModal();
        });

        dialog.addEventListener("close", () => {
            const iframe = dialog.querySelector("iframe");

            if (iframe) {
                iframe.src = iframe.src; // Reset the video
            }
        });
    });
};
